const initialValue = {
  poNumber: '',
  mpn: '',
}

export default initialValue
